/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/progress-bar/custom-elements';

import { defineCustomElement as defineOsdsProgressBar } from '@ovhcloud/ods-stencil/components/progress-bar/custom-elements/osds-progress-bar.js';

export const OsdsProgressBar = /*@__PURE__*/createReactComponent<JSX.OsdsProgressBar, HTMLOsdsProgressBarElement>('osds-progress-bar', undefined, undefined, defineOsdsProgressBar);
